import React from "react";
import { FiMail, FiMapPin } from "react-icons/fi";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";

const footerGroups = [
  {
    title: "Customer Support",
    links: [
      ["Contact Us", "/contact"],
      ["Shipping Information", "/shipping"],
      ["Returns", "/returns"],
      ["Payment & Billing", "/payments"],
      ["Order & Cancellation", "/orders"],
      ["Food Safety & Allergens", "/allergens"],
      ["FAQs", "/faqs"],
      ["Shopping Cart", "/cart"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About Us", "/about"],
      ["Accessibility", "/accessibility"],
      ["Sustainability", "/sustainability"],
      ["Security", "/security"],
      ["Your Privacy Choices", "/privacy-choices"],
    ],
  },
  {
    title: "Legal & Policies",
    links: [
      ["Policy Centre", "/policies"],
      ["Privacy Policy", "/privacy"],
      ["Terms & Conditions", "/terms"],
      ["Cookie Policy", "/cookies"],
      ["Promotions Policy", "/promotions"],
      ["Product Information", "/product-information-policy"],
      ["Acceptable Use", "/acceptable-use"],
      ["Intellectual Property", "/copyright"],
      ["Reviews & User Content", "/reviews-policy"],
      ["Website Disclaimer", "/disclaimers"],
    ],
  },
  {
    title: "Quick Bites",
    links: [
      ["Shop All", "/shop"],
      ["Gourmet Gifts", "/shop/gifts"],
      ["New Arrivals", "/shop?new=true"],
      ["Favorites", "/shop?wishlist=true"],
    ],
  },
];

const Footer = () => {
  return (
    <>
      <footer className="site-footer" role="contentinfo">
        <div className="shell site-footer__grid">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__logo">
              <img src={siteConfig.logo} alt={siteConfig.brandName} />
            </Link>
            <p>{siteConfig.description}</p>
            <ul className="site-footer__contact">
              <li>
                <FiMail aria-hidden="true" /> {siteConfig.contact.email}
              </li>
              <li>
                <FiMapPin aria-hidden="true" /> {siteConfig.contact.address}
              </li>
            </ul>
          </div>
          {footerGroups.map((group) => (
            <div className="site-footer__group" key={group.title}>
              <h3>{group.title}</h3>
              <ul>
                {group.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="site-footer__bottom shell">
          <span>
            © {new Date().getFullYear()} {siteConfig.brandName}. All rights
            reserved.
          </span>
          <div
            className="site-footer__payments"
            aria-label="Supported payment methods"
          >
            <span>Secure payments:</span>
            <b>VISA</b>
            <b>Mastercard</b>
            <b>AMEX</b>
            <b>PayPal</b>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
